<taly-partner-banner/>
<div class="container">
    <taly-payment-option/>
<!--       TODO don't remove this will required code after prod release -->
<!--     <taly-trusted-parterns/> -->
    <taly-partner-faq/>
    <taly-integration/>
    <taly-sell-with-taly/>
</div>
